<template>
 <base-layout>
	<div class="height-100">
		<!-- Search Top Section Starts -->
		<template>
			<div class="row m0">
				<div class="left-section-search">
					<h2 class="header-label"> FDNS Visit Assistance</h2>
				</div>
				<div class="right-section-search" v-if="$route.name != 'ess-fdns-visit-history'">
					<ob-input class="search-field-bar" placeholder="Search Questions" v-model="searchText" @keyup.enter.native="searchKeyup()"></ob-input>
					<ob-button class="search-btn-field" :disabled="searchText.trim() == ''" @click="search" style="margin-right: 10px;">Search</ob-button>
          <ul class="list-unstyled list-inline pull-right">
            <li  style="margin-right: -10px;">
              <ob-button class="filter-btn" type="secondary" @click="showFilters = true" >Filters <i class="fa fa-chevron-down" style="margin:0px"></i></ob-button>
              <ob-button v-if="showClearFilter" type="link" @click="clearFilter">Clear Filter</ob-button>
            </li>
            <li>
              <div class="dashboard__mydbFilterHolder text-left">
                <fdns-filters v-if="showFilters" @cancel="cancelFilter" @apply="applyFilter"></fdns-filters>
              </div>
            </li>
            <li>  
              <ob-button type="secondary" @click="reportFdnsVisit" >Report FDNS Visit</ob-button>
              </li>
            <li> 
              <ob-button @click="isAddQuestion" v-if="$route.name != 'fdns-visit-history'">Add Question</ob-button>
            </li>
          </ul>
				</div>
			</div>
		</template>
		<template>
			<div class="fdns-header_tabs">
				<ul>
					<li :class="{activeTab: $route.name == 'ess-fdns-visit-question'}">
						<router-link :to="routerVisitQuestion"><span>FDNS Visit Questions</span></router-link>
					</li>
					<li :class="{activeTab: $route.name == 'ess-fdns-visit-history'}">
						<router-link :to="routeToVisitHistory"><span>FDNS Visit History</span></router-link>
					</li>
				</ul>
        <div class="fdns-header-tabs-right" v-if="$route.name != 'ess-fdns-visit-history' && $route.name != 'fdns-visit-settings'">
				  <a @click="downloadFDNSVisit" style="font-weight:bold;font-style:italic;text-decoration:underline" v-if="showDownloadQuestionBtn">Download Questionnaire</a> 
        </div>
        <div class="fdns-header-tabs-right" v-if="$route.name == 'ess-fdns-visit-history'">
          <template v-if="$route.name == 'ess-fdns-visit-history' && selectedReport != null && selectedReportDetails != null">
    				  <ob-button type="secondary" @click="downloadFDNSVisit" v-if="showDownloadQuestionBtn" >Download Questionnaire</ob-button>
              <ob-button @click="isEditFdnsVisit" v-if="selectedReportDetails.FdnsModel.CanEdit">Edit FDNS Visit</ob-button>
              <ob-button v-tooltip="'You don\'t have permission to edit'" v-else>Edit FDNS Visit</ob-button>
          </template>
        </div>
				
			</div>
      <div id="fdnstabcontent" style="height: calc(100% - 85px); overflow: auto;background: #fff;">
				<router-view ref="routerview"></router-view>
			</div>

		</template>
		<!-- Search Top Section Ends -->

		  <add-question-popup :openAddQuestionPopUp.sync="toOpenAddQuestionPopUp" @questionAdded="onQuestionAdded"></add-question-popup>
	</div>
  </base-layout>
</template>
<script>
import utils from '@/components/Core/utils.js'
import FDNSQuestionAns from "./FDNS/FDNSQuestionAndAnswer.vue";
import ViewAuditReportPopUp from "./FDNS/FDNS-PopUp/ViewAuditReportPopup.vue";
import AddQuestionPopUp from "./FDNS/FDNS-PopUp/AddQuestions.vue";
import FDNSFilters from "./FDNS/FDNS-PopUp/FDNSFilters.vue";
import c from '@/components/Core/constants.js'
import {
  required,
  requiredIf,
  maxLength,
  alpha,
  email,
  minValue
} from "vuelidate/lib/validators";
export default {
  data() {
    return {
      showFilters: false,
      nameFdnsTitle: "",
      routeToVisitHistory: {
        name: "ess-fdns-visit-history",
        query: this.$route.query
      },
      routerVisitQuestion: {
        name: "ess-fdns-visit-question",
        query: this.$route.query
      },
      openModal: false,
      questionCategoryOption: {
        data: [
          {
            id: "Organization",
            text: "Organization"
          },
          {
            id: "Candidate",
            text: "Candidate"
          },
          {
            id: "Signatory Authority",
            text: "Signatory Authority"
          },
          {
            id: "Supervisor",
            text: "Supervisor"
          },
          {
            id: "Work Location",
            text: "Work Location"
          },
          {
            id: "Pay Information",
            text: "Pay Information"
          }
        ],
        placeholder: "Question Category"
      },

      questionTypeOptions: {
        data: [
          {
            id: "Employer Questions",
            text: "Organization"
          },
          {
            id: "Employee Generic Questions",
            text: "Employee Generic Questions"
          },
          {
            id: "Employee Specific Questions",
            text: "Employee Specific Questions"
          },
          {
            id: "FDNS Visit History",
            text: "FDNS Visit History"
          }
        ],
        placeholder: "Question Type"
      },

      questionTypeData: "",

      validate: false,
      isValid: true,
      toOpenAddQuestionPopUp: false
    };
  },
  components: {
    "fdns-question-ans": FDNSQuestionAns,
    "add-question-popup": AddQuestionPopUp,
    "view-auditreport-popup": ViewAuditReportPopUp,
    "fdns-filters": FDNSFilters
  },
  computed: {
    showClearFilter() {
      return this.$store.getters.getFDNSShowClearFilter;
    },
    searchText: {
      get() {
        return this.$store.getters.getFDNSSearchFilterField("SearchText");
      },
      set(v) {
        this.$store.commit("updateFDNSSearchFilterField", {
          field: "SearchText",
          value: v.trim()
        });
      }
    },
    selectedReport() {
      return this.$store.getters.getFDNSSelectedReport;
    },
    selectedReportDetails() {
      return this.$store.getters.getFDNSSelectedReportDetails;
    },

    showDownloadQuestionBtn() {
      return (
        this.$store.getters.getFDNSConsultantId != null &&
        this.$store.getters.getFDNSEmpOrgId != null
      );
    },

    searchFilter() {
      return this.$store.getters.getFDNSSearchFilter;
    },
    consultantId() {
      return this.$store.getters.getFDNSConsultantId;
    },
    orgId() {
      return this.$store.getters.getFDNSEmpOrgId;
    }
  },
  methods: {
    searchKeyup(){
      if(this.searchText.trim() != ''){
          this.search()
      }
    },
    search() {
      this.$store.commit("updateFDNSIsFilterApplied", true);
      if (this.consultantId == "" && this.orgId == "") {
        let message = "";
        if (this.isHRManager) {
          message = "Please select a consultant";
        } else {
          message = "Please select an organization";
        }

        this.$message({
          type: "error",
          message: message
        });
      } else {
        this.$loading({ loadingText: "Searching..." });
        let url = `/FDNSAudit/SearchQuestions?consultantId=${
          this.consultantId
        }&empOrgId=${this.orgId}&isESS=true`;

        ajax.put(url, this.searchFilter, res => {
          this.$loading().close();
          if (res.data.State === true) {
            this.$store.commit("updateFDNSQuestionList", res.data.resultList);
          } else {
            this.ESSEnableDisable(res)
            this.$message({
              type: "error",
              message: res.data.Message
            });
          }
        });
      }
    },
    onQuestionAdded(type) {
      if (type == "EmployerSpecific") {
        if (this.$route.name == "employer-questions") {
          // refresh
          this.$refs.routerview.init();
        } else {
          this.$router.push({ name: "employer-questions" });
        }
      } else if (type == "EmployeeSpecific") {
        if (
          this.$route.name == "employee-specific-questions" ||
          this.$route.name == "ess-fdns-visit-question"
        ) {
          // refresh
          this.$refs.routerview.reloadQuestions();
        } else {
          if (this.isConsultant) {
            this.$router.push({ name: "ess-fdns-visit-question" });
          } else {
            this.$router.push({ name: "employee-specific-questions" });
          }
        }
      }
    },
    orgscroll(w) {
      this.toScroll(document.getElementById(w).offsetTop - 50);
    },
    toScroll(scrollTop) {
      let container = document.getElementById("page");
      container.scrollTop = scrollTop;
    },
    isAddQuestion() {
      if (this.isConsultant && utils.IsNullOrEmpty(this.orgId)) {
        this.$message({
          type: "error",
          message: "Please select an organization"
        });
      } else {
        this.toOpenAddQuestionPopUp = true;
      }
    },
    cancelFilter() {
      this.showFilters = false;
    },
    clearFilter() {
      this.$store.commit("updateFDNSResetSearchFilter");
      this.$refs.routerview.init();
    },
    applyFilter() {
      this.showFilters = false;
      this.search();
    },
    isEditFdnsVisit() {
      this.$router.push({
        name: "ess-fdns-report-visit",
        query: { type: "Edit", RepId: this.selectedReport.ReportId }
      });
    },
    reportFdnsVisit() {
      this.$router.push({
        name: "ess-fdns-report-visit",
        query: { type: "Report" }
      });
    },
    downloadFDNSVisit() {
      let type = "EmployeeSpecific";
      if (this.$route.name == "employer-questions") {
        type = "EmployerSpecific";
      }
      let url = `/FDNSAudit/DownloadQuestionnarie?type=${type}&consultantId=${
        this.consultantId
      }&empOrgId=${this.orgId}`;
      if (this.$route.name == "ess-fdns-visit-history") {
        url = `/FDNSAudit/DownloadFDNSReportVisit?reportId=${
          this.selectedReport.ReportId
        }&empOrgId=${this.orgId}`;
      }

      this.$loading({ loadingText: "Downloading..." });
      ajax.get(url, {}, res => {
        this.$loading().close();
        if (res.data.State === true) {
          let downloadUrl = res.data.DownloadUrl + "&download=true";
          window.open(downloadUrl);
        } else {
          this.ESSEnableDisable(res)
          this.$message({
            type: "error",
            message: res.data.Message
          });
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
/*header section START*/
.header-label {
  color: #143361;
  font-weight: 700;
  margin: 0px;
  font-size: 17px;
  line-height: 33px;
}

.left-section-search {
  width: 25%;
  float: left;
}

.right-section-search {
  width: 75%;
  display: inline-block;
  text-align: right;
}

.search-field-bar {
  width: 30%;
  display: inline-block;
}

.search-btn-field {
  margin-left: -6px;
  margin-bottom: 2px;
}
/*header section END
//Main Section start*/
// .answer-txt {
//   display: block;
//   margin: 10px 0;
//   width: 100%;
//   margin-left: 15px;
// }

// .manual-txt {
//   display: inline;
//   color: #b3b2bb;
//   font-size: 13px;
//   font-weight: 600;
// }

// /* Change color of dropdown links on hover */

// .fixed-dropdown {
//   position: fixed;
//   right: 15px;
//   top: 190px;
//   z-index: 2;
// }

// .heading-txt {
//   padding: 15px 15px 15px 22px;
//   border-bottom: 1px solid #4a90e3;
//   position: -webkit-sticky;
//   position: sticky;
//   top: -15px;
//   background: #fff;
//   z-index: 1;
//   p {
//     color: #4a90e3;
//     font-size: 16px;
//     font-weight: 600;
//   }
// }

// .Fdns-audit-fluid {
//   padding: 0px 20px 0 20px;
// }

// .fdnsaudit-container {
//   background: #fff;
// }

// .fdns-footer {
//   padding: 0 0 20px 0;
//   text-align: center;
// }
/*// TABS STARTS*/
.fdns-header_tabs {
  min-height: 34px;
  margin: 20px 0 0 0;
  border-bottom: 1px solid #dfdfdf;
  ul {
    padding: 0;
    width: 60%;
    display: inline-block;
    margin-top: 5px;
    li {
      list-style: none;
      display: inline;
      padding: 7px 10px 8px 10px;
      a {
        font-size: 13px;
        font-weight: 600;
        color: #b0b2b5;
      }
    }
    li.activeTab {
      border-bottom: 3px solid #2d4972;
      a {
        color: #143361;
      }
    }
  }
}

.fdns-header-tabs-right {
  text-align: right;
  width: 39%;
  display: inline-block;
}
/*// TABS ENDS*/
.height-100 {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/EmpFDNSFiles.vue